/**
 * Audiocity 2026 — movimiento discreto.
 * Progressive enhancement: si no hay IntersectionObserver, no se agrega
 * ninguna clase y todo el contenido queda visible de forma normal.
 */
(function () {
  if (!('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('ac-js-motion');

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ac-in');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );

  function observeAll() {
    document.querySelectorAll('.ac-reveal:not(.ac-in)').forEach(function (el) {
      io.observe(el);
    });
  }

  observeAll();

  // Vuelve a observar si Shopify re-renderiza secciones (editor de temas, facetas).
  document.addEventListener('shopify:section:load', observeAll);
  document.addEventListener('facets:updated', observeAll);
})();


/* =====================================================================
   AUDIOCITY - AJUSTES 16 SEP 2026
   Bloque anexo: marquesina superior, mega menu con foto dinamica,
   collage de banners de coleccion, textos de la barra de confianza,
   pie de pagina y detalles varios. No borrar.
   ===================================================================== */
(function () {
  'use strict';
  var H = document.documentElement;
  var path = location.pathname.replace(/\/+$/, '') || '/';

  /* ---- marcas de contexto ---- */
  if (/^\/products\//.test(path)) H.classList.add('ac-en-producto');
  var mCol = path.match(/^\/collections\/([^\/]+)/);
  if (mCol) H.classList.add('ac-col-' + mCol[1]);
  if (path === '/') H.classList.add('ac-en-home');

  /* 22 sep 2026: se retiró la carga de Montserrat desde Google Fonts (sistema tipográfico Sora + IBM Plex). */

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  /* =================================================================
     1. MARQUESINA SUPERIOR (todas las paginas)
     ================================================================= */
  var AVISOS = [
    'Envíos a toda Colombia',
    'Showroom en Laureles, Medellín',
    'Precios con IVA incluido',
    'Financie hasta 36 cuotas con tarjeta de crédito o 24 cuotas con Addi',
    'Factura electrónica',
    'Asesoría e ingeniería de audio',
    'Demostración con cita previa'
  ];
  function marquesina() {
    if (document.querySelector('.ac-aviso')) return;
    var head = document.querySelector('.shopify-section-group-header-group.header-section') ||
               document.querySelector('header') || document.body.firstElementChild;
    if (!head || !head.parentNode) return;
    var grupo = AVISOS.map(function (t) { return '<span class="ac-aviso__i">' + t + '</span>'; }).join('');
    var el = document.createElement('div');
    el.className = 'ac-aviso';
    el.setAttribute('role', 'complementary');
    el.setAttribute('aria-label', 'Avisos de Audiocity');
    el.innerHTML = '<div class="ac-aviso__pista">' +
      '<div class="ac-aviso__grupo">' + grupo + '</div>' +
      '<div class="ac-aviso__grupo" aria-hidden="true">' + grupo + '</div>' +
      '</div>';
    head.parentNode.insertBefore(el, head);
  }

  /* =================================================================
     2. BARRA DE CONFIANZA: textos y demostracion
     ================================================================= */
  function confianza() {
    var items = document.querySelectorAll('.ac-conf__item');
    if (!items.length) return;
    Array.prototype.forEach.call(items, function (it) {
      var tEl = it.querySelector('.ac-conf__titulo');
      var xEl = it.querySelector('.ac-conf__texto');
      var t = tEl ? tEl.textContent.trim().toLowerCase() : '';
      if (t.indexOf('env') === 0 && xEl) {
        xEl.textContent = 'Envíos a toda Colombia; también puede recoger su pedido en nuestro showroom de Laureles, Medellín.';
      }
      if (t.indexOf('demostra') === 0) {
        it.classList.add('ac-conf--demo');
        if (H.classList.contains('ac-en-producto')) {
          it.parentNode && it.parentNode.removeChild(it);
        } else if (xEl) {
          xEl.textContent = 'Escúchelo en nuestro showroom de Laureles. Con cita previa: escríbanos por WhatsApp y le confirmamos la disponibilidad del equipo.';
        }
      }
    });
  }

  /* =================================================================
     3. PIE DE PAGINA
     ================================================================= */
  function pie() {
    var foot = document.querySelector('footer');
    if (!foot) return;
    Array.prototype.forEach.call(foot.querySelectorAll('h1,h2,h3,h4,.menu__heading__default,.menu__heading'), function (h) {
      if (h.childElementCount === 0 && h.textContent.trim() === 'Audiocity') h.textContent = 'Conversemos';
    });
    Array.prototype.forEach.call(foot.querySelectorAll('input[type=email],input[type=text]'), function (i) {
      i.placeholder = 'tucorreo@aqui.com';
      i.setAttribute('aria-label', 'Correo electrónico');
    });
  }

  /* =================================================================
     4. ITEM "MARCAS" DEL MENU EN NEGRO
     ================================================================= */
  function marcas() {
    Array.prototype.forEach.call(document.querySelectorAll('.menu-list__list-item'), function (li) {
      var txt = (li.textContent || '').trim().toLowerCase();
      if (txt.slice(0, 6) === 'marcas') li.classList.add('ac-menu-marcas');
    });
  }

  /* =================================================================
     5. FOTO DEL WA-251 SIN FONDO BLANCO
     ================================================================= */
  function wa251() {
    Array.prototype.forEach.call(document.querySelectorAll('.ac-figura img'), function (img) {
      var s = (img.getAttribute('src') || '') + ' ' + (img.getAttribute('alt') || '');
      if (/wa.?251|wa.?47/i.test(s)) img.classList.add('ac-sin-fondo');
    });
  }

  /* =================================================================
     6. MEGA MENU: la foto cambia segun la subcategoria bajo el cursor
     ================================================================= */
  var cacheCol = {};
  function traerColeccion(handle) {
    if (cacheCol[handle]) return cacheCol[handle];
    cacheCol[handle] = fetch('/collections/' + handle + '/products.json?limit=4', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { return (j.products || []).filter(function (p) { return p.images && p.images.length; }); })
      .catch(function () { return []; });
    return cacheCol[handle];
  }
  function pintarTarjetas(cont, prods, etiqueta) {
    var cards = cont.querySelectorAll('.resource-card');
    if (!cards.length || !prods.length) return;
    for (var i = 0; i < cards.length; i++) {
      var p = prods[i % prods.length];
      if (!p) continue;
      var img = cards[i].querySelector('img');
      if (img) {
        var u = p.images[0].src.split('?')[0];
        img.setAttribute('src', u + '?width=600');
        img.setAttribute('srcset', u + '?width=400 400w, ' + u + '?width=600 600w, ' + u + '?width=900 900w');
        img.setAttribute('alt', p.title);
        img.style.objectFit = 'contain';
        img.style.background = '#fff';
      }
      var ttl = cards[i].querySelector('.resource-card__title, .resource-card__content span, .resource-card__heading');
      if (ttl) ttl.textContent = etiqueta || p.title;
    }
  }
  function handleDe(a) {
    var href = a && a.getAttribute && a.getAttribute('href');
    if (!href) return null;
    var m = href.match(/\/collections\/([^\/?#]+)/);
    return m ? m[1] : null;
  }
  function megamenu() {
    Array.prototype.forEach.call(document.querySelectorAll('.mega-menu'), function (mm) {
      var cont = mm.querySelector('.mega-menu__content');
      if (!cont) return;
      var padre = mm.closest('.menu-list__list-item');
      var enlacePadre = padre ? padre.querySelector('.menu-list__link, a') : null;
      var hPadre = handleDe(enlacePadre);
      var pintado = false;
      function porDefecto() {
        if (pintado || !hPadre) return;
        pintado = true;
        traerColeccion(hPadre).then(function (ps) { pintarTarjetas(cont, ps, null); });
      }
      if (padre) {
        padre.addEventListener('pointerenter', porDefecto);
        padre.addEventListener('focusin', porDefecto);
      }
      Array.prototype.forEach.call(mm.querySelectorAll('.mega-menu__link'), function (a) {
        var h = handleDe(a);
        if (!h) return;
        var pinta = function () {
          pintado = true;
          traerColeccion(h).then(function (ps) {
            pintarTarjetas(cont, ps, (a.textContent || '').trim());
          });
        };
        a.addEventListener('pointerenter', pinta);
        a.addEventListener('focus', pinta);
      });
    });
  }

  /* =================================================================
     7. COLLAGE DEL BANNER DE COLECCION: productos elegidos a mano
     ================================================================= */
  var COLLAGE = {
    'parlantes-de-techo-y-colgantes': [
      'biamp-community-mask6ct-bl-parlantes-ambientales-200-w-6-5-par',
      'dream-sound-xpat-630wf-altavoces-de-techo-6-wifi-y-bluetooth-par',
      'biamp-community-p30dt-bl-altavoz-colgante-negro'
    ],
    'sonido-ambiental': [
      'ld-systems-dqor5tb-parlantes-interior-exterior-5-2-vias-16-70-100-v-negro-par',
      'spottune-omni-track-altavoz-inalambrico-para-sistemas-de-iluminacion-de-riel',
      'jbl-vma2120-amplificador-con-bluetooth-120-w'
    ],
    'microfonos-y-audifonos': [
      'pioneer-dj-hdj-x10-k-audifonos-dj-cerrados-50-mm',
      'vento-kit1-microfono-inalambrico-doble-de-mano-mh29-con-receptor-wm332-uhf',
      'shure-blx288-pg58-sistema-inalambrico-dual-con-dos-transmisores-de-mano-y-capsula-pg58'
    ],
    'cabinas-y-parlantes': [
      'ld-systems-icoa15abt-cabina-activa-15-1200-w-profesional-bluetooth',
      'electrovoice-everse-8-parlante-activo-recargable-bluetooth',
      'vento-118xs-subwoofer-activo-18'
    ],
    'cabinas-y-subwoofers': [
      'ld-systems-icoa15abt-cabina-activa-15-1200-w-profesional-bluetooth',
      'electrovoice-everse-8-parlante-activo-recargable-bluetooth',
      'vento-118xs-subwoofer-activo-18'
    ]
  };
  function collage() {
    if (!mCol) return;
    var lista = COLLAGE[mCol[1]];
    if (!lista) return;
    var fotos = document.querySelectorAll('.ac-colhero__foto');
    if (!fotos.length) return;
    lista.slice(0, fotos.length).forEach(function (handle, i) {
      fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !p.featured_image) return;
          var img = fotos[i].querySelector('img');
          if (!img) return;
          var u = String(p.featured_image).split('?')[0];
          if (u.indexOf('//') === 0) u = location.protocol + u;
          img.setAttribute('src', u + '?width=800');
          img.setAttribute('srcset', u + '?width=500 500w, ' + u + '?width=800 800w, ' + u + '?width=1200 1200w');
          img.setAttribute('alt', p.title);
          img.style.objectFit = 'contain';
        })
        .catch(function () {});
    });
  }

  /* =================================================================
     8. BARRA DE CATEGORIAS EN DOS FILAS
     <overflow-list> manda a un menu "Mas" todo lo que no cabe en una
     linea. Con dos filas eso sobra: se le pide mostrar todo y se vigila
     que ningun item vuelva al desbordamiento.
     ================================================================= */
  function categorias() {
    var ol = document.querySelector('header-menu .overflow-menu');
    if (!ol) return;

    function liberar() {
      try { if (typeof ol.showAll === 'function') ol.showAll(); } catch (e) {}
      Array.prototype.forEach.call(ol.querySelectorAll('[slot="overflow"]'), function (li) {
        li.removeAttribute('slot');
      });
      repartir();
    }

    /* Dos filas parejas sea cual sea el numero de categorias: la mitad arriba y
       la mitad abajo, salvo que no quepan, y entonces se reparte por el ancho. */
    function repartir() {
      var items = ol.querySelectorAll(':scope > li:not([slot])');
      var n = items.length;
      if (!n) return;
      var ancho = ol.getBoundingClientRect().width;
      if (ancho < 750) { ol.style.removeProperty('--ac-cols'); return; }
      var minimo = ancho < 1024 ? 104 : 112;
      var cols = Math.ceil(n / 2);
      var caben = Math.max(2, Math.floor(ancho / minimo));
      if (cols > caben) cols = caben;
      ol.style.setProperty('--ac-cols', cols);
    }

    [0, 150, 500, 1200].forEach(function (t) { setTimeout(liberar, t); });

    try {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          if (t && t.getAttribute && t.getAttribute('slot') === 'overflow') { liberar(); return; }
        }
      }).observe(ol, { attributes: true, attributeFilter: ['slot'], subtree: true });
    } catch (e) {}

    var temp;
    window.addEventListener('resize', function () {
      clearTimeout(temp);
      temp = setTimeout(liberar, 180);
    });
  }

  ready(function () {
    try { marquesina(); } catch (e) {}
    try { confianza(); } catch (e) {}
    try { pie(); } catch (e) {}
    try { marcas(); } catch (e) {}
    try { wa251(); } catch (e) {}
    try { megamenu(); } catch (e) {}
    try { categorias(); } catch (e) {}
    /* 22 sep 2026: el collage del banner ahora se arma en Liquid con la colección 'destacados' (sections/audiocity-coleccion-hero.liquid). */
  });
})();
